// открыть меню
$('header .btn-mob-menu').click(function (event) {

    // Закроем окно контактной информации
    if($('header .btn-mob-phone').hasClass('active')) {
        $('header .btn-mob-phone').removeClass('active');
        $('body').removeClass('active');
        $('header .for-contact-info-mobi').removeClass('active');
    }

    $('html, body').animate({scrollTop: $('html').offset().top}, 'fast');

    $('header .with-drop-click').parent().removeClass('active');

    $(this).toggleClass('active');
    $('body').toggleClass('active');
    $('header .parent-mob-menu').toggleClass('active');
});

// открыть вложенный список меню
$('header .with-drop-click').click(function (e) {

    if ($(window).width() < 768) {
        e.preventDefault();
    }

    $(this).parent().addClass('active');
});


// закрыть текущий список меню
//пока временное примитивное решение. так как в меню всего одна вложенность
$('header .menu .btn-back-menu').click(function (e) {
    $('header .with-drop-click').parent().removeClass('active');
});

//Открытие моб окна  контактной информацией
$('header .btn-mob-phone').click(function (event) {

    //Закроем меню
    if($('header .btn-mob-menu').hasClass('active')){
        $('header .btn-mob-menu').removeClass('active');
        $('body').removeClass('active');
        $('header .parent-mob-menu').removeClass('active');
        $('header .with-drop-click').parent().removeClass('active');
    }


    $('html, body').animate({scrollTop: $('html').offset().top}, 'fast');

    $(this).toggleClass('active');
    $('body').toggleClass('active');
    $('header .for-contact-info-mobi').toggleClass('active');

});

if ($(window).width() < 768) {
    $("header .parent-mob-menu .container .for-top-menu-mobi .with-second-list").append($("header .for-md-menu-top .menu"));
    $("header .parent-mob-menu .container .for-bottom-menu-mobi").append($("header .for-md-menu-bottom nav"));
    // $("header .parent-mob-menu .container .for-top-menu-mobi .menu").addClass('second-list');

    $("header .for-contact-info-mobi .container .for-phone-contact-info-mobi").append($("header .for-contact-info-phone-md .phone"));
    $("header .for-contact-info-mobi .container .for-email-contact-info-mobi").append($("header .for-contact-info-email-md .email"));


}
else {

    //Закроем окно контактной информации
    if($('header .btn-mob-phone').hasClass('active')) {
        $('header .btn-mob-phone').removeClass('active');
        $('body').removeClass('active');
        $('header .for-contact-info-mobi').removeClass('active');
    }

    //Закроем меню
    if($('header .btn-mob-menu').hasClass('active')){
        $('header .btn-mob-menu').removeClass('active');
        $('body').removeClass('active');
        $('header .parent-mob-menu').removeClass('active');
        $('header .with-drop-click').parent().removeClass('active');
    }

    $("header .for-md-menu-top").append($("header .parent-mob-menu .container .for-top-menu-mobi .with-second-list .menu"));
    $("header .parent-mob-menu .container .for-bottom-menu-mobi").append($("header .for-md-menu-bottom nav"));
    $("header .for-md-menu-bottom ").append($("header .parent-mob-menu .container .for-bottom-menu-mobi nav"));


    $("header .for-contact-info-phone-md").append($("header .for-contact-info-mobi .container .for-phone-contact-info-mobi.phone"));
    $("header .for-contact-info-email-md").append($("header .for-contact-info-mobi .container .for-email-contact-info-mobi .email"));

}

$(window).resize(function () {
    if ($(window).width() < 768) {
        $("header .parent-mob-menu .container .for-top-menu-mobi .with-second-list").append($("header .for-md-menu-top .menu"));
        $("header .parent-mob-menu .container .for-bottom-menu-mobi").append($("header .for-md-menu-bottom nav"));

        $("header .for-contact-info-mobi .container .for-phone-contact-info-mobi").append($("header .for-contact-info-phone-md .phone"));
        $("header .for-contact-info-mobi .container .for-email-contact-info-mobi").append($("header .for-contact-info-email-md .email"));
    }
    else {
        //Закроем меню
        if($('header .btn-mob-menu').hasClass('active')){
            $('header .btn-mob-menu').removeClass('active');
            $('body').removeClass('active');
            $('header .parent-mob-menu').removeClass('active');
            $('header .with-drop-click').parent().removeClass('active');
        }

        //Закроем окно контактной информации
        if($('header .btn-mob-phone').hasClass('active')) {
            $('header .btn-mob-phone').removeClass('active');
            $('body').removeClass('active');
            $('header .for-contact-info-mobi').removeClass('active');
        }

        $("header .for-md-menu-top").append($("header .parent-mob-menu .container .for-top-menu-mobi .with-second-list .menu"));
        $("header .parent-mob-menu .container .for-bottom-menu-mobi").append($("header .for-md-menu-bottom nav"));
        $("header .for-md-menu-bottom ").append($("header .parent-mob-menu .container .for-bottom-menu-mobi nav"));


        $("header .for-contact-info-phone-md").append($("header .for-contact-info-mobi .container .for-phone-contact-info-mobi .phone"));
        $("header .for-contact-info-email-md").append($("header .for-contact-info-mobi .container .for-email-contact-info-mobi .email"));
    }
});


// WEBPACK FOOTER //
// ./resources/js/snippets/header.js